module.exports = __webpack_public_path__ + "static/thoma-5a09817b615e40da8457ba50b9c50db1.png";